import script from "./IOrderSubscribeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IOrderSubscribeItem.vue?vue&type=script&setup=true&lang=js"

import "./IOrderSubscribeItem.vue?vue&type=style&index=0&id=16f4ca1a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f4ca1a"]])

export default __exports__